import React, { useState, useEffect } from 'react'

// redux
import { connect } from "react-redux";

// styles
import { PerPageContainer } from '../../../../styles/Themes/StylesTheme1/MyAccountStyles'
import { AccountSettingsContainer } from '../../../../styles/Themes/StylesTheme1/AccountSettingsStyles'

// components
import MyAccountLeftBar from '../../../../Themes/MyAccountTheme1/includes/MyAccountLeftBar'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// includes
import ChangeDetails from './includes/ChangeDetails'
// import ChangeEmail from './includes/ChangeEmail'
import ChangePassword from './includes/ChangePassword'


function AccountSettings(props) {
    // props
    const {
        parentProps,

        setGlobalLoading
    } = props

    // states
    const [currentPageType, setCurrentPageType] = useState("")

    // checking current route
    useEffect(() => {
        if (parentProps?.match?.params?.type) {
            // setting global loading
            setGlobalLoading(true)

            // setting current route
            setCurrentPageType(parentProps.match.params.type)

            // setting global loading
            setGlobalLoading(false)
        }
    }, [parentProps.match.params.type])

    return (
        <PerPageContainer>
            <div className="container">
                <div className="per-page-container-inner d-md-flex flex-wrap align-items-start">
                    <MyAccountLeftBar />

                    <AccountSettingsContainer className="media-body">
                        <div className="d-flex form-content">
                            {
                                /* left sec */
                                currentPageType === "personal-details" ? (
                                    <div className="lt-sec col">
                                        <div className="inner">
                                            {/* <ChangeEmail /> */}
                                            <ChangeDetails />
                                        </div>
                                    </div>
                                ) : null
                            }

                            {
                                /* right sec */
                                currentPageType === "passwords" ? (
                                    <div className="rt-sec col">
                                        <div className="inner">
                                            <ChangePassword />
                                        </div>
                                    </div>
                                ) : null
                            }

                        </div>
                    </AccountSettingsContainer>
                </div>
            </div>
        </PerPageContainer>
    )
}


const getDataFromStore = (state) => {
    return {
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(AccountSettings);